"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SttFormControl = function SttFormControl(props) {
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], props);
};
var _default = SttFormControl;
exports["default"] = _default;